import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.9976 15.0534L6.34375 9.39953L7.39758 8.3457L11.9976 12.9457L16.5976 8.3457L17.6514 9.39953L11.9976 15.0534Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
